import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import EventBanner from "../App/EventBanner";
import StreamTabs from "../../controllers/StreamTabs";
import PageBackgroundGlow from "../../controllers/PageBackgroundGlow";
import PageContainer from "../../components/PageContainer";
import SideModule from "../../components/SideModule";
import { ModalContextProvider } from "../../context/ModalContext";
import "./style.scss";
import { usePlayerContext } from "../../context/PlayerContext";
import PlayerBannerBlock from "../../blocks/PlayerBannerBlock";
import { useStreamContext } from "../../context/StreamContext";

export default ({ page, children }) => {
    const {streams} = useStreamContext();
    const {
        tabletView,
        isShowPlayerHalls,
        currentModule,
    } = usePlayerContext();
    const params = useParams();
    const className = 'page-halls';

    useEffect(() => {
        addPageStyles();
    }, [params]);

    function addPageStyles() {
        const hallsPage = document.querySelector('.halls-page-root');

        hallsPage.style.backgroundImage = `url(${page.settings.backgroundUrl})`;

        page?.settings?.backgroundFixed
            ? hallsPage.classList.add('halls-page-root--background-fixed')
            : hallsPage.classList.remove('halls-page-root--background-fixed');
    }

    const isPaddingTopPage = streams.length > 1;

    return (
        <div
            className={`${className} ${currentModule ? `-hidePageBlocks` : ''} ${tabletView ? `-tabletView` : ''}`}
            id="page-broadcast"
        >
            <EventBanner settings={page?.settings} />
            <PageBackgroundGlow />
            <StreamTabs />
            <PageContainer isPaddingTop={isPaddingTopPage} directonRow>
                <ModalContextProvider>
                    <section className={`${className}-content`}>
                        <PlayerBannerBlock isShow={page?.settings?.showPlayer} settings={page?.settings} />
                        {children}
                    </section>
                    <SideModule
                        settings={page?.settings}
                        isFullscreenChat={!isShowPlayerHalls}
                        isOpenModule={page?.settings?.isMobileOpenModule}
                    />
                </ModalContextProvider>
            </PageContainer>
        </div>
    );
}
